import React from "react";
import { Clock, TrendingUp, Zap, Target } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const ValuePropositionSection: React.FC = () => {
  const benefits = [{
    icon: Clock,
    metric: "5 hours",
    description: "saved per week on content creation",
    detail: "Stop spending hours crafting the perfect prompt from scratch"
  }, {
    icon: TrendingUp,
    metric: "10x faster",
    description: "output generation with expert prompts",
    detail: "Get professional results in minutes, not hours"
  }, {
    icon: Zap,
    metric: "95%",
    description: "of users see immediate improvements",
    detail: "Start seeing results from day one"
  }, {
    icon: Target,
    metric: "300+",
    description: "expert-crafted prompts ready to use",
    detail: "Covering every use case from marketing to development"
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-primary/5 to-secondary/10">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <Badge variant="secondary" className="mb-4 px-4 py-2 text-sm font-medium">
            Proven Results
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Why 10,000+ Users Choose Get Prompts</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Stop wasting time on trial and error. Get immediate results with our proven system.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => {
          const IconComponent = benefit.icon;
          return <Card key={index} className="text-center border-none shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="p-6">
                  <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="h-8 w-8 text-primary" />
                  </div>
                  <div className="text-3xl font-bold text-primary mb-2">
                    {benefit.metric}
                  </div>
                  <p className="font-semibold text-foreground mb-2">
                    {benefit.description}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {benefit.detail}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-muted-foreground">
            Join thousands of professionals who've already transformed their workflow
          </p>
        </div>
      </div>
    </section>;
};
export default ValuePropositionSection;